import React, { useState, useEffect } from "react";
import { Box, Heading, Button, Layer, Text } from "grommet";
import { Close } from "grommet-icons";
import { useNavigate } from "react-router-dom";
import dashboardImage from "../assets/user/dashboard.png";
import skillSummaryImage from "../assets/user/skill_summary.png";
import questionsGif from "../assets/gif/questions.gif";
import retakeAssessmentImage from "../assets/user/retake_assessment.png";
import courseRecommendationsGif from "../assets/gif/course_recommendations.gif";
import dropdownGif from "../assets/gif/dropdown.gif";
import DedicatedLearningGif from "../assets/gif/dedicated_learning.gif";

const userSlides = [
  {
    name: "Welcome",
    text: "Welcome to HPE Digital Skill Advisor! This is your homepage. Easily customize your self-assessment by selecting multiple skill combinations, difficulty levels, and question counts. Create a comprehensive skill gap analysis to identify growth areas and get personalized learning recommendations. Start exploring your potential today! Click 'Next' to proceed.",
    image: retakeAssessmentImage,
  },
  {
    name: "Dashboard Overview",
    text: "The dashboard provides tailored course recommendations based on your assessment results, helping you enhance your skills effectively. Additionally, we recommend the HPE Digital Learner Subscription to further enrich your learning experience.",
    image: dashboardImage,
  },
  {
    name: "Navigation Menu",
    text: "The avatar dropdown menu provides quick navigation options: click 'Home' to go directly to the homepage, select 'Dashboard' to view your Assessment History, or choose 'Logout' to securely sign out.",
    image: dropdownGif,
  },
  {
    name: "Skill Summary Report",
    text: "The Skill Summary Report provides insights into your assessed skills. The 'View Questions' button allows you to review your previous answers and the 'View Course Recommendations' section provides curated learning paths to enhance your skills.",
    image: skillSummaryImage,
  },
  {
    name: "View Questions",
    text: "In the 'View Questions' section, you can review your answered questions along with the answers. This helps you analyze your responses and understand areas for improvement.",
    image: questionsGif,
  },
  {
    name: "Course Recommendations",
    text: "The 'View Course Recommendations' section provides tailored course suggestions based on your assessment results. Explore the best learning paths to enhance your skills and advance your career.",
    image: courseRecommendationsGif,
  },
  {
    name: "Dedicated Learning",
    text: "If you wish to request for custom or dedicated training, click on the button 'To request customised/dedicated learning experience click here'. That's the end of the tour! Now you're ready to explore and make the most of HPE Digital Skill Advisor. If you need any assistance, reach out to hpeskill.advisor@hpe.com.",
    image: DedicatedLearningGif,
  },
];

const UserTourModal = ({ showModal, setShowModal, userid }) => {
  // console.log("userid ----------------------------------", userid);
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (showModal) {
      setCurrentSlide(0);
    }
  }, [showModal]);

  // Map over slides to update the Skill Summary Report slide text with clickable links.
  const slides = userSlides.map((slide) => {
    if (slide.name === "Skill Summary Report") {
      return {
        ...slide,
        text: (
          <>
            The Skill Summary Report provides insights into your assessed skills
            and suggests learning resources to improve them. The page includes
            two key buttons:
            <br />
            <span
              style={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(`/quiz-results/${userid}`)}
            >
              1. View Questions
            </span>
            : Allows you to review your previous answers and understand your
            assessment performance.
            <br />
            <span
              style={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(`/quiz-results/${userid}`)}
            >
              2. View Course Recommendations
            </span>
            : Provides curated learning paths to help you enhance your skills
            based on your assessment results.
          </>
        ),
      };
    }
    return slide;
  });

  return (
    showModal && (
      <Layer
        onEsc={() => setShowModal(false)}
        onClickOutside={() => setShowModal(false)}
        responsive={false}
        background="white"
      >
        <Box
          width="auto"
          height="auto"
          pad={{ top: "medium", horizontal: "xsmall" }}
          round="small"
          overflow="auto"
          alignSelf="center"
        >
          <Box
            direction="row"
            align="center"
            margin={{ bottom: "small" }}
            justify="between"
          >
            <Text size="medium" margin={{ left: "small" }}>
              {`Step ${currentSlide + 1} of ${slides.length}`}
            </Text>
            <Heading
              level={2}
              margin="none"
              alignSelf="center"
              textAlign="center"
              style={{ flex: 1, marginRight: "55px" }}
              color={"dark-3"}
            >
              HPE Digital Skill Advisor Tour
            </Heading>
            <Button
              icon={<Close color="dark-3" />}
              margin={{ right: "small" }}
              onClick={() => setShowModal(false)}
              plain
              style={{ marginLeft: "auto" }}
              color={"black"}
            />
          </Box>
          <Box align="center" pad="small" flex="grow" width="100%">
            <Heading level={3} margin={{ bottom: "small" }} color={"dark-3"}>
              {slides[currentSlide].name}
            </Heading>
            <img
              src={slides[currentSlide].image}
              alt="Slide Image"
              style={{
                maxWidth: "100%",
                maxHeight: "45vh",
                objectFit: "contain",
              }}
            />
            <Text textAlign="center" margin={{ top: "small" }} size="medium">
              {slides[currentSlide].text}
            </Text>
          </Box>
        </Box>
        <Box pad={{ bottom: "small", horizontal: "medium" }}>
          <Box
            direction="row"
            justify="end"
            margin={{ top: "small" }}
            width="100%"
          >
            {currentSlide > 0 && (
              <Button
                label="Previous"
                onClick={() => setCurrentSlide(currentSlide - 1)}
                secondary
                style={{ color: "black" }}
              />
            )}
            {currentSlide < slides.length - 1 ? (
              <Button
                label="Next"
                onClick={() => setCurrentSlide(currentSlide + 1)}
                primary
                margin={{ left: "medium" }}
              />
            ) : (
              <Button
                label="Close"
                onClick={() => setShowModal(false)}
                primary
                margin={{ left: "medium" }}
              />
            )}
          </Box>
        </Box>
      </Layer>
    )
  );
};

export default UserTourModal;
